<template>
  <div>
    <ots-main-title></ots-main-title>
    <div class="detailBox clearfix">
      <div class="detailBox-l">
        <div class="title">
          <h1>{{ showMsg.planName }}</h1>
          <div class="col_blue cp" @click="auditNext">
            <span>审核下一条</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
  
        <!-- 基础信息部分 -->
        <div class="base">
          <h2>基础信息</h2>
          <ul>
            <li>
              <em>姓名：</em><span>{{ showMsg.realName }}</span>
            </li>
            <li>
              <em>性别：</em><span>{{ showMsg.sex }}</span>
            </li>
            <li>
              <em>证件类型：</em><span>{{ showMsg.cardType }}</span>
            </li>
            <li>
              <em>证件号：</em><span>{{ showMsg.cardNo }}</span>
            </li>
            <li v-if="baseDefList.isShowPhone">
              <em>手机号：</em><span>{{ showMsg.phone }}</span>
            </li>
            <li v-if="baseDefList.isShowEmail">
              <em>邮箱：</em><span>{{ showMsg.email }}</span>
            </li>
            <li style="display: flex;" v-show="photoContrastType == 2">
              <em>基础照片：</em>
              <div style="width: 116px; height: auto; display: inline-block; border: 1px solid #ccc;">
                <img :src="showMsg.photo" alt="" style="width: 100%; height: auto;">
              </div>
            </li>


            <!-- 自定义基础 -->
            <li v-for="(item, key) in showMsgBasics" :key="key">
              <em>{{ item.displayName + "：" }}</em
              ><span>{{ item.value }}</span>
            </li>
            <li v-for="(item, key) in showMsgBasicsImg" :key="key" class="extImg">
              <em>{{ item.displayName + "：" }}</em>
              <img
                :src="item.value"
                alt=""
                width="120"
                @click="lookImg(item.value)"
              />
            </li>
          </ul>
          <div class="showMsgPhoto">
            <img
              :src="showMsg.photoUrl"
              alt=""
              @click="lookImg(showMsg.photoUrl)"
            />
            <p style="text-align: center;"><i class="iconfont f12" :class="stateClass[options[showMsg.photoState]]"></i><span style="margin-left: 8px;">{{showMsg.photoState}}</span></p>
          </div>
          
        </div>

        <!-- 院校信息部分 -->
        <div class="school">
          <h2>院校信息</h2>
          <ul>
            <li v-if="showMsg.school">
              <em>就读院校：</em><span>{{ showMsg.school.name }}</span>
            </li>
            <li v-if="showMsg.station">
              <em>{{ isSetStateName }}：</em
              ><span>{{ showMsg.station.name }}</span>
            </li>
            <!-- 自定义院校 -->
            <li v-for="(item, key) in showMsgSchool" :key="key">
              <em>{{ item.displayName + "：" }}</em
              ><span>{{ item.value }}</span>
            </li>
            <li
              v-for="(item, key) in showMsgSchoolImg"
              :key="key"
              class="extImg"
            >
              <em>{{ item.displayName + "：" }}</em
              ><img
                :src="item.value"
                alt=""
                width="120"
                @click="lookImg(item.value)"
              />
            </li>
          </ul>
        </div>

        <!-- 报考信息部分 -->
        <div class="applyMsg">
          <h2>报考信息</h2>
          <ul v-if="optionSession">
            <li>
              <em>报考考点：</em><span>{{ showMsgPlace }}</span>
            </li>
          </ul>

          <!-- 当前批次未设置 "报名选考点场次" -->
          <ul v-if="!optionSession">
            <li>
              <em>报考课程：</em><span>{{ courseText }}</span>
            </li>
            <li v-if="optionalExam== 1">
              <em>预约考试日期：</em><span>{{ optionalExamDate}}</span>
            </li>
          </ul>
          <!-- 当前批次设置了 "报名选考点场次" -->
          <ul v-else>
            <li v-for="item in timeAndSessionIdDtoList" :key="item.courseId">
              <em>考试场次：</em><span>{{ item.sessionName }}</span><br />
              <em>报考课程：</em><span>{{ item.courseName }}</span><br />
              <em>考试时间：</em><span style="width: auto;">{{ item.beginTime }} ~ {{ item.endTime }}</span>
            </li>
          </ul>
        </div>

        <div class="exempt" v-if="exemptFlag">
          <h2>免考信息</h2>
          <ul>
            <li>
              <em>免考课程：</em><span>{{ courseIdsExempt.courseName }}</span>
            </li>
            <li>
              <em>免考原因：</em><span>{{ courseIdsExempt.reasonName }}</span>
            </li>
            <li style="display: flex;">
              <em>材料证明网站：</em><span>{{ courseIdsExempt.reasonProveText }}</span>
            </li>
            <li style="display: flex;">
              <em>免考材料：</em>
              <div class="showFile">
                <div v-for="item in courseIdsExempt.fileList" :key="item.id" @click="openFile(item.url)">
                  <img :src="item.fileext == 'pdf'? defaultUrl: item.url" alt="">
                  <p>{{item.filename}}</p>
                </div>
              </div>
            </li>
          </ul>

          <!-- <h2>免考材料</h2>
          <div class="showFile">
            <div v-for="item in courseIdsExempt.fileList" :key="item.id" @click="openFile(item.url)">
              <img :src="item.fileext == 'pdf'? defaultUrl: item.url" alt="">
              <p>{{item.filename}}</p>
            </div>
          </div> -->
        </div>

        <div class="exempt" v-if="studentFilesList.length > 0">
          <h2>报名材料</h2>
          <ul>
            <!-- <li>
              <em>免考课程：</em><span>{{ courseIdsExempt.courseName }}</span>
            </li>
            <li>
              <em>免考原因：</em><span>{{ courseIdsExempt.reasonName }}</span>
            </li> -->
            <li style="display: flex;" v-for="item in studentFilesList" :key="item.id">
              <em>{{ item.filename.split("_")[0] }}：</em>
              <div class="showFile">
                <div @click="openFile(item.url)">
                  <!-- <img :src="item.fileext == 'pdf'? defaultUrl: item.url" alt=""> -->
                  <img :src="defaultUrl" alt="" v-if="item.fileext == 'pdf'">
                  <img :src="wordDefaultUrl" alt="" v-else-if="item.fileext == 'doc' || item.fileext == 'docx'">
                  <img :src="item.url" alt="" v-else>
                  <p>{{ item.filename }}<br><br>
                    <span v-if="item.agentResultCode > -1 " style="color: red;       width:  86px;">AI初审结果：</span>
                    <span v-if="item.agentResultCode > -1 " style="color: cadetblue; width: 350px;">{{ item.agentResultDesc }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>

          <!-- <h2>免考材料</h2>
          <div class="showFile">
            <div v-for="item in courseIdsExempt.fileList" :key="item.id" @click="openFile(item.url)">
              <img :src="item.fileext == 'pdf'? defaultUrl: item.url" alt="">
              <p>{{item.filename}}</p>
            </div>
          </div> -->
        </div>

      </div>

      <!-- 页面右侧审核部分 -->
      <div class="right">
        <div class="rightMsg-r">
          <div
            class="showResult"
            v-if="
              (showMsg.stateType === '待初审' && isFirstAudit) ||
                (showMsg.stateType === '待终审' && !isFirstAudit)
            "
          >
            <template v-if="isCanHandle">
              <h1>报名信息审核</h1>
              <div class="examine-state">
                <el-form :disabled="!isCanHandle">
                  <el-form-item label="审核结果">
                    <el-radio-group v-model="ruleForm.state">
                      <el-radio-button :label="0">通过</el-radio-button>
                      <el-radio-button :label="1">驳回</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <template v-if="ruleForm.state">
                    <el-form-item label="驳回原因">
                      <el-input
                        type="textarea"
                        v-model="ruleForm.reason"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="重新提交报考信息">
                      <el-radio-group v-model="ruleForm.flag">
                        <el-radio-button :label="0">允许</el-radio-button>
                        <el-radio-button :label="1">不允许</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </template>
                </el-form>
              </div>
              <div class="rightMsg">
                <el-button round @click="goBack" :disabled="!isCanHandle">取消</el-button>
                <el-button
                  round
                  type="primary"
                  @click="rightNext"
                  :disabled="!isCanHandle"
                  >确定</el-button
                >
              </div>
            </template>
            <template>
              <p class="col_grayZ mb10">
                <span>最终状态：</span
                ><span class="col_black">{{ showMsg.stateType }}</span>
              </p>
            </template>
          </div>
          <div class="showResult" v-else>
            <div class="showResult-t">
              <h1>审核结果</h1>
              <img
                :src="
                  showMsg.stateType && showMsg.stateType.indexOf('不通过') > -1
                    ? require('../../assets/img/unpass.png')
                    : require('../../assets/img/pass.png')
                "
                alt=""
              />
              <p
                :style="{
                  color:
                    showMsg.stateType &&
                    showMsg.stateType.indexOf('不通过') > -1
                      ? '#FE5958'
                      : '#1DBF60',
                }"
              >
                {{
                  showMsg.stateType == "待终审"
                    ? "初审通过，待终审"
                    : showMsg.stateType
                }}
              </p>
            </div>
            <div
              class="showResult-b"
              v-if="
                showMsg.stateType && showMsg.stateType.indexOf('不通过') > -1
              "
            >
              <span>不通过原因：</span>
              <p class="cause">{{ showMsg.reason }}</p>
              <span>是否允许重新报名：</span>
              <p>{{ showMsg.isUpdate === "是" ? "允许" : "不允许" }}</p>
            </div>
          </div>
        </div>
        <div class="auditInfo">
          <div v-if="showMsg.primaryDate">
            <p class="col_grayQ">初审时间</p>
            <p>{{ showMsg.primaryDate }}</p>
          </div>
          <div v-if="showMsg.primaryUser">
            <span class="col_grayQ">初审人</span>
            <p>{{ showMsg.primaryUser }}</p>
          </div>
          <div v-if="showMsg.ultimateDate">
            <span class="col_grayQ">终审时间</span>
            <p>{{ showMsg.ultimateDate }}</p>
          </div>
          <div v-if="showMsg.ultimateUser">
            <span class="col_grayQ">终审人</span>
            <p>{{ showMsg.ultimateUser }}</p>
          </div>
        </div>
      </div>

      <div class="right HistoryPhoto" v-show="HistoryPhoto.length > 0">
        <div class="Photo_title">历史审核失败照片</div>
        <div class="main">

          <div class="Photo_Left">
            <div v-for="item in HistoryPhoto.length" :key="item">
              <div class="dit"></div>              
              <div class="line"></div>
              <div class="dit" v-if="item == HistoryPhoto.length"></div>              
            </div>
          </div>

          <div class="Photo_Right">
            <div v-for="(item, key) in HistoryPhoto" :key="key">
              <div class="time">{{item.photoAddDate}}</div>
              <img :src="item.photo" alt="" >
            </div>
          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { getSinglePlan, getUserHistoryPhotoApi } from "@/http/modules/examSet/examBatch";
import { selectOneSignUp, examineList, studentFilesListAPI } from "@/http/modules/custom";
import { getPlanCourseExemptScopeAPI, getStudentCourseExemptListAPI } from "@/http/modules/baseSet/course";

export default {
  data() {
    return {
      defaultUrl: require("@/assets/img/PDFIcon.png"),
      wordDefaultUrl: require("@/assets/img/WORDIcon.jpg"),
      stateClass: {
        green: {'icon-tongguo': true, 'col_green': true},
        red: {'icon-weitongguo': true, 'col_red': true},
        orange: {'icon-daishenhe': true, 'col_orange': true}
      },
      options: { // options[showMsg.photoState]
        人工通过: "green",
        系统通过: "green",
        系统不通过: "red",
        无报名照片: "red",
      },
      query: {},
      ruleForm: {
        flag: 0,
        reason: "",
        planId: "",
        state: 0, //0通过 1不通过
        stuId: "",
      },
      currentPlanInfo: {},
      showMsg: {
        station: {},
        school: {},
      },
      optionalExamDate:'',
      showMsgBasics: [],
      showMsgBasicsImg: [],
      showMsgSchool: [],
      showMsgSchoolImg: [],
      showMsgImg: "",
      showMsgPlace: "",
      isSetStateName: "教学点",
      isCanHandleSecond: "",
      /* ** 是否设置考点场次信息 ** */
      optionSession: "",
      optionalExam:'',
      /* ** 若 当前批次设置了 "考点场次信息", 存储 "考点场次" 数据 ** */
      timeAndSessionIdDtoList: [],

      // 审核失败照片
      HistoryPhoto: [],

      // 人身审核方式
      photoContrastType: "",

      // 免考数据
      courseIdsExempt: "",

      exemptFlag: false,

      studentFilesList: [],
      baseDefList: {},
    };
  },

  computed: {
    isFirstAudit() {
      return this.$route.name == "applyFirstDetail";
    },
    /**********************
     * @courseText 报考课程
     *********************/
    courseText() {
      return this.showMsg && this.showMsg.course
        ? this.showMsg.course.map((item) => item.courseName).join("，")
        : "";
    },
    /***********************
     * @currentStuId 考生Id
     **********************/
    currentStuId() {
      return this.$route.query.stuid;
    },

    isCanHandle() {
      let isCanHandle = this.$route.query.isCanHandle.toString();

      if (isCanHandle == "false") {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    "$route.query": {
      handler(val) {
        this.getDetailList(val);
        this.getHistoryPhoto();
        this.initData();
      },
      deep: true,
    },
    showMsg: {
      handler() {},
      deep: true,
    },
  },
  mounted() {
    this.$store.dispatch('fetchCardTypeList');
    this.query = this.$route.query;
    this.getDetailList();
    this.getHistoryPhoto();

    this.initData();
    this.getSystemName();
  },
  methods: {
    async initData() {
      this.courseIdsExempt = [];
      this.exemptFlag = false;
      const { planId, stuid: studentUserId} = this.$route.query
      const { data } = await getStudentCourseExemptListAPI({planId, studentUserId})
      if (data && data.length > 0) {
        this.exemptFlag = true;
        this.courseIdsExempt = data[0];
      }

      // 报考材料
      let params = { stuUserId: this.$route.query.stuid, planId }
      const { code: FileCode, data: FileData } = await studentFilesListAPI(params);
      if (FileCode) {
        this.studentFilesList = FileData;
      }

    },

    getSystemName() {
      this.$api.system.getSystemNameFN({ tenant: window.localStorage.getItem("tenant") }).then((res) => {
        let phoneObj = res.data.baseDefList.find((item) => item.fieldName == "phone");
        if(phoneObj) {
          this.baseDefList.isShowPhone = phoneObj.showInPage == 1 ? true : false;
        }
        let emailObj = res.data.baseDefList.find((item) => item.fieldName == "email");
        if(emailObj) {
          this.baseDefList.isShowEmail = emailObj.showInPage == 1 ? true : false;
        }
      })
    },
    openFile(url) {
      window.open(url);
    },

    /**********************************************
     * @param { 获取历史审核失败照片 }
     **********************************************/
    async getHistoryPhoto() {
      const { planId, stuid: stuId} = this.$route.query
      let { code, data } = await getUserHistoryPhotoApi({planId, stuId})
      if (code == 1) this.HistoryPhoto = data
    },

    lookImg(img) {
      this.lookBigImage(img);
    },

    /**********************************************
     * @this (isShow_Place_Time)报考信息部分数据处理
     **********************************************/
    isShow_Place_Time() {
      // (1) 判断当前批次 "设置考点场次" 是否开启
      this.$api.applyManage.getCurrentPlan({ planId: this.$route.query.planId }).then((res) => {
        if (res.code == 1) {
          this.photoContrastType = res.data.photoContrastType;
          this.optionSession = res.data.optionalSession == 1;
          this.optionalExam  = res.data.optionalExamDate;
        }
      });
    },

    /***************************************
     * @this (getDetailList)查询考生信息
     ***************************************/
    getDetailList(obj) {
      this.showMsgBasics = [];
      this.showMsgSchool = [];
      this.showMsgBasicsImg = [];
      this.showMsgSchoolImg = [];
      let queryObj = obj ? obj : this.query;
      let { planId, stuid } = queryObj;
      this.ruleForm.planId = planId;
      this.ruleForm.stuId = stuid;
      this.ruleForm.isAudit = this.isFirstAudit ? 1 : 2;
      selectOneSignUp({ planId, stuIds: stuid })
        .then((res) => {
          // 1. 证件类型
          // let cardType = ["身份证", "护照", "士官证", "港澳台身份证"];
          // res.data.cardType = cardType[res.data.cardType - 1];
          res.data.cardType = this.$store.getters.getCardTypeName(res.data.cardType);

          // 2. 性别
          res.data.sex = res.data.sex == 1 ? "男" : "女";
          // 3. 自定义
          res.data.extData.map((e) => {
            if (e.title == 1 && e.type != "imageUpload") {
              this.showMsgBasics.push(e);
            } else if (e.title == 1 && e.type == "imageUpload") {
              this.showMsgBasicsImg.push(e);
            } else if (e.title == 2 && e.type == "imageUpload") {
              this.showMsgSchoolImg.push(e);
            } else if (e.title == 2 && e.type != "imageUpload") {
              this.showMsgSchool.push(e);
            }
          });
          // 4. 考点
          this.showMsgPlace = res.data.place ? res.data.place.name : "";
          // 5. 考点场次信息
          this.timeAndSessionIdDtoList = res.data.timeAndSessionIdDtoList;
          this.optionalExamDate = res.data.optionalExamDate
          // 6. 报考信息部分
          this.isShow_Place_Time();
          return this.$api.applyAudit.examineByOne({ planId, stuid });
        }).then((res) => {
          this.showMsg = res.data;
        });
    },

    /***************************************
     * @this (examine)报名信息审核
     ***************************************/
    examine() {
      this.$api.applyAudit.examine(this.ruleForm).then((res) => {
        const { code, data } = res;
        if (code == 1) {
          this.applyMsgDialog = false;
          this.$message.success("操作成功");
          if (data) {
            for (let key in data) {
              this.showMsg[key] = data[key];
            }
          }
          this.resetForm();
        }
      });
      this.getDetailList(this.$route.query);
    },

    /***************************************
     * @this (resetForm)重置审核接口参数
     ***************************************/
    resetForm() {
      this.ruleForm = {
        isAudit: this.isFirstAudit ? 1 : 2,
        flag: 0,
        reason: "",
        planId: "",
        state: 0,
        stuId: "",
      };
    },

    /***************************************
     * @this (goBack)报名信息审核(取消)
     ***************************************/
    goBack() {
      this.$router.push({
        name: this.isFirstAudit ? "applyFirst" : "applyAudit",
      });
    },

    /***************************************
     * @this (rightNext)报名信息审核(确定)
     ***************************************/
    rightNext() {
      this.examine();
    },

    /***************************************
     * @this (auditNext)审核下一条
     ***************************************/
    auditNext() {
      // (1) 获取路由参数
      const { path, name } = this.$route;
      // (2) 声明 初审 OR 终审
      const isAudit = name == "applyFirstDetail" ? 1 : 2;
      // (3) 查询当前批次审核结束时间
      let params_planId = this.$route.query.planId;
      // (4) 查询当前批次接口
      getSinglePlan({ planId: params_planId }).then(({ data }) => {
        // (5) 终审时间之前可审核
        if (Date.now() > new Date(data.endAudit).getTime()) {
          this.isCanHandleSecond = false;
        } else {
          this.isCanHandleSecond = true;
        }
        // (6) 查询下一条审核数据, 配置跳转参数
        return this.$api.applyAudit.examineNextFn({
          isAudit,
          userId: this.currentStuId,
          planId: this.$route.query.planId,
        });
      }).then((res) => {
          if (res.code) {
            let { stuid, planId } = res.data;
            this.$router.push({
              path: path,
              query: { stuid, planId, isCanHandle: this.isCanHandleSecond },
            });
          }
      });
    },
  },
};
</script>

<style lang="less" scoped>
// 2023年10月17日
.HistoryPhoto {
  border-radius: 8px;
  padding: 16px 8px;
  box-sizing: border-box;
  background: #FFF;
  width: 240px;
  height: 368px; 
  margin-top: 16px;
  display: flex;
  overflow: auto;
  flex-direction: column;
  .Photo_title {
    text-align: center; 
    color: #45494D;
    width: 100%;
    height: 16px;
    margin-bottom: 16px;
    font-weight: 700;
    font-size: 16px;
  }
  .main {
    display: flex;
    flex-wrap: wrap;
  }
  .Photo_Left {
    width: 16px;
    height: auto;
    &>div {
      height: 160px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .dit {
        width: 16px;
        height: 16px;
        background: #EBF5FF;
        border: 1px solid #006AFF;
        box-sizing: border-box;
        border-radius: 50%;
      }
      .line {
        width: 2px;
        height: 144px;
        background: #CCC;
        border-radius: 50%;
      }
    }
  }
  .Photo_Right {
    width: 190px;
    &>div {
      height: 160px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .time {
        width: 100%;
        height: 14px;
        color: #9299A6;
        text-align: center;
        line-height: 16px;
      }
      img {
        width: 96px;
        height: 130px;
        margin-bottom: 8px;
      }
    }
  }
}

.extImg {
  width: 100%;
  display: flex !important;
  align-items: center;
}
.detailBox {
  position: relative;
  .detailBox-l {
    width: calc(100% - 264px);
    padding: 24px;
    background: #fff;
    border-radius: 8px;
    float: left;
    box-sizing: border-box;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 24px;
      border-bottom: 1px solid #f1f2f5;
      h1 {
        color: #2d2f33;
        font-size: 20px;
      }
    }
    .base {
      width: 75%;
      position: relative;
      h2 {
        border-top: none;
      }
      .showMsgPhoto {
        position: absolute;
        margin-right: 58px;        
        right: -180px;
        top: 42px;
        &>img {
          width: 116px;
          height: 152px;
        }
      }
    }

    h2 {
      font-size: 16px;
      color: #2d2f33;
      padding: 32px 0;
      border-top: 1px solid #f1f2f5;
    }
    ul {
      li {
        display: inline-block;
        font-size: 14px;
        margin-bottom: 24px;
        em {
          color: #9299a6;
          display: inline-block;
          vertical-align: middle;
          width: 120px;
          text-align: right;
          font-style: normal;
        }
        span {
          display: inline-block;
          vertical-align: middle;
          width: auto;
        }
      }
      li:last-child {
        margin-bottom: 32px;
      }
    }
    .applyMsg li {
      display: block !important;
    }
  }
  .right {
    float: right;
    .rightMsg-r {
      background: #fff;
      width: 240px;
      border-radius: 8px;
      padding: 24px;
      box-sizing: border-box;

      .showResult {
        box-sizing: border-box;
        background: #fff;
        text-align: center;
        .showResult-t {
          display: flex;
          flex-direction: column;
          align-items: center;
          h1 {
            color: #2d2f33;
            font-size: 20px;
          }
          img {
            margin: 12px 0 12px 0;
          }
          p {
            font-size: 14px;
            color: #fe5958;
            margin-bottom: 12px;
          }
        }
        .showResult-b {
          text-align: left;
          padding-top: 16px;
          border-top: 1px solid #f1f2f5;
          span {
            font-size: 14px;
            color: #9299a6;
          }
          p {
            font-size: 14px;
            color: #45494d;
            margin-top: 4px;
          }
          .cause {
            margin-bottom: 16px;
          }
        }
      }
      .showResult {
        position: relative;
        text-align: left;
        padding-bottom: 2px;
        h1 {
          margin-bottom: 32px;
          text-align: left;
        }
        /deep/ .el-radio-button__inner {
          margin-right: 16px;
          color: #45494d !important;
          background: #f4f5f8 !important;
          font-size: 13px;
          border-radius: 4px !important;
          border: 1px solid #dadde6 !important;
          width: 64px;
          height: 32px;
          line-height: 32px;
          padding: 0;
        }
        /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          background: #ebf5ff !important;
          border: 1px solid #006aff !important;
          color: #006aff !important;
          box-shadow: none;
        }
        /deep/ .el-form-item__label {
          display: block;
          line-height: 1;
          padding-bottom: 16px;
          width: 100%;
          text-align: left;
        }

        /deep/ .el-button.is-round {
          padding: 10px 23px;
        }
      }
      .rightMsg {
        position: relative;
        left: -24px;
        bottom: -60px;
        width: 240px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        box-shadow: 0px -8px 12px 0px rgba(0, 0, 0, 0.05);
        border-radius: 0px 0px 8px 8px;
        background: #fff;
      }
    }
    .auditInfo {
      padding-left: 5px;
      margin-top: 16px;
      & > div {
        margin-top: 8px;
      }
    }
  }
}
.examine-state {
  margin-top: 32px;
}
.showFile {
  display: flex;
  flex-wrap: wrap;
  &>div {
    width: 600px;
    display: flex;
    align-items: center;
    margin-right: 16px;
    margin-bottom: 16px; 
    border: 1px dashed #CCC; 
    border-radius: 8px;
    cursor: pointer;
    &>img {
      width: 120px; 
      height: 120px;
    }
    &>p{
      margin-left: 16px;
    }
  }
}
</style>
